<template>
    <template v-if="cell.title">
        <div class="a-table__head-title">
            {{ cell.title }}
        </div>
    </template>
    <template v-else>
        <a-link
            v-if="cell.to && isTypeOne"
            class="a-table__head-link"
            v-bind="cell"
            type="regular"
            :size="cell.size || 'paragraph'"
        />
        <a-link
            v-else-if="cell.to"
            class="a-table__head-link"
            v-bind="cell"
            :size="cell.size || 'paragraph'"
        />
        <div v-if="cell.val" class="a-table__head-text">
            {{ cell.val }}
        </div>
        <div v-if="cell.desc" class="a-table__head-desc">
            {{ cell.desc }}
        </div>
        <div v-if="cell.label" class="a-table__head-label">
            {{ cell.label }}
        </div>
        <div v-if="cell.product" class="a-table__head-product">
            {{ cell.product }}
        </div>
    </template>
</template>

<script setup>
import ALink from '@core/components/link/link.vue';

defineOptions({
    name: 'STableHeadCell',
});


defineProps({
    cell: {
        type: Object,
        required: true,
    },
    isTypeOne: {
        type: Boolean,
        default: false,
    },
});
</script>

<style lang="postcss" scoped>
.a-table__head-text {
    @mixin paragraph;

    font-weight: 700;
    color: var(--av-nav-primary);
}

.a-table__head-desc {
    color: var(--av-nav-primary);
}

.a-table__head-title {
    @mixin hero-subtle;
    color: var(--av-nav-primary);
}

.a-table__head-label {
    @mixin body;

    color: var(--av-fixed-success);
    margin-bottom: 4px;
}

.a-table__head-product {
    font-size: 24px;
    line-height: 24px;
    font-weight: bold;
}
</style>
